import React, { useState, useEffect } from "react";
import axios from "axios";
import { ClipLoader } from "react-spinners";
import ForecastDay from "./ForecastDay";

export default function WeatherForecast(props) {
  const [forecastData, setForecastData] = useState("");

  useEffect(() => {
    setForecastData("");
  }, [props.city]);

  function handleResponse(response) {
    setForecastData(response.data.daily);
  }

  function getForecastData(cityName) {
    const apiKey = "733615547b11515efo464ab9111t0c1b";
    let units = "metric";
    let apiUrl = `https://api.shecodes.io/weather/v1/forecast?query=${cityName}&key=${apiKey}&units=${units}`;

    axios.get(apiUrl).then(handleResponse);
  }

  if (forecastData) {
    return (
      <div className="WeatherForecast">
        <section className="pt-3">
          <div className="row">
            {forecastData.map(function (dailyForecastData, index) {
              if (index > 0 && index < 7) {
                return (
                  <div className="col" key={index}>
                    <ForecastDay data={dailyForecastData} units={props.units} />
                  </div>
                );
              } else {
                return null;
              }
            })}
          </div>
        </section>
      </div>
    );
  } else {
    getForecastData(props.city);
    return (
      <div className="WeatherForecast">
        <ClipLoader
          color="#029CFD"
          loading={true}
          size={70}
          speedMultiplier={1}
          cssOverride={override}
        />
      </div>
    );
  }
}

const override = {
  display: "block",
  margin: "0 auto",
};
